import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import Image from 'partials/Image';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import ImageOverlay from 'partials/ImageOverlay';

import Media from 'css/Media';

class ImageModule extends Component {
    
    render() {
        const { data, prevModule } = this.props;

        return (
            <ModuleWrapper 
                bleed={data.bleed}
                bigger={!data.bleed && !data.toggle_size}
                prevModule={prevModule}
            >
                <Container 
                    grid 
                    bleed={data.bleed} 
                    mobileBleed={!data.toggle_size}
                    bigger={!data.toggle_size}
                >
                    <StyledGridElement
                        colStart={{default: 1,s: data.bleed ? 1 : !data.toggle_size ? 3 : 5}}
                        colEnd={{default: 8, s: data.bleed ? 24 : !data.toggle_size ? 22 : 20}}
                    >
                        <ImageOverlay image={data.image}>
                            <Image image={data.image} />
                        </ImageOverlay>
                    </StyledGridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default ImageModule;

const ModuleWrapper = styled.div`

    ${props => props.prevModule === 'rich_text' && css`
        margin: ${props => props.theme.spacing.elementXS} 0 ${props => props.theme.spacing.elementXS};
        
        ${props => props.bleed && css`
            margin: ${props => props.theme.spacing.elementM} 0 ${props => props.theme.spacing.elementM};
        `}

        ${Media.greaterThan('s')`
            margin: ${props => props.theme.spacing.elementS} 0 ${props => props.theme.spacing.elementM};
            
            ${props => props.bleed && css`
                margin: ${props => props.theme.spacing.blockXS} 0 ${props => props.theme.spacing.blockXS};
            `}
        `}

        ${Media.greaterThan('l')`
            margin: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.elementXL};
            
            ${props => props.bleed && css`
                margin: ${props => props.theme.spacing.blockM} 0 ${props => props.theme.spacing.blockXS};
            `}
        `}
    `}

    ${props => props.prevModule !== 'rich_text' && css`
        margin: ${props => props.theme.spacing.elementXS} 0 ${props => props.theme.spacing.elementXS};
        
        ${props => props.bleed && css`
            margin: ${props => props.theme.spacing.elementM} 0 ${props => props.theme.spacing.elementM};
        `}

        ${Media.greaterThan('s')`
            margin: ${props => props.theme.spacing.blockXS} 0 ${props => props.theme.spacing.blockXS};
        `}

        ${Media.greaterThan('l')`
            margin: ${props => props.theme.spacing.blockL} 0 ${props => props.theme.spacing.blockXS};
            
            ${props => props.bleed && css`
                margin: ${props => props.theme.spacing.blockM} 0 ${props => props.theme.spacing.blockXS};
            `}
        `}
    `}
`

const StyledGridElement = styled(GridElement)`
    > div {
        div {
            width: 100%;
            img {
                width: 100%;
                max-width: none;
            }
        }
    }
`
